import { render, staticRenderFns } from "./AssignmentWidget.vue?vue&type=template&id=2363f35c&scoped=true"
import script from "./AssignmentWidget.vue?vue&type=script&lang=js"
export * from "./AssignmentWidget.vue?vue&type=script&lang=js"
import style0 from "./AssignmentWidget.vue?vue&type=style&index=0&id=2363f35c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2363f35c",
  null
  
)

export default component.exports